
export default function ArticlePartTwo() {
  return (
    <>
      {/* Calculator Section */}
      <section id="calculator" className="mb-12 scroll-mt-24">
        <div className="max-w-4xl mx-auto px-6">
          <h2 className="text-3xl font-bold text-gray-900 mb-6">
            Disabled Veteran Property Tax Exemption Texas Calculator: How Much Will You Save?
          </h2>

          <div className="mb-10">
            <img
              src="https://public.readdy.ai/ai/img_res/794da110fce88ff08ac813eb197d1a58.jpg"
              alt="Disabled veteran couple calculating property tax exemption savings in El Paso Texas"
              className="w-full h-80 object-cover object-top rounded-xl shadow-lg mb-6"
            />
          </div>

          <div className="prose prose-lg max-w-none">
            <p className="text-gray-700 leading-relaxed mb-6">
              Using a disabled veteran property tax exemption Texas calculator is straightforward once you understand the formula. Your savings depend on three variables: your VA disability rating, your home&apos;s appraised value, and the combined tax rate of all taxing entities that levy taxes on your property in El Paso County. The combined effective tax rate in El Paso typically ranges from 2.50 percent to 2.80 percent depending on your exact location and which special districts apply to your property. For the examples below, we use an average combined rate of 2.69 percent, which is representative of most El Paso neighborhoods.
            </p>
            <p className="text-gray-700 leading-relaxed mb-6">
              The basic formula for calculating your savings with a partial exemption under Section 11.22 is simple. Take your exemption amount based on your VA rating, multiply it by the combined tax rate, and divide by 100. The result is your annual savings. For the 100 percent disabled veteran property tax exemption under Section 11.131, the calculation is even simpler: your entire assessed value multiplied by the combined tax rate divided by 100 equals your total savings, because you pay nothing.
            </p>

            <div className="bg-white rounded-xl shadow-lg overflow-hidden mb-8">
              <div className="bg-teal-600 text-white p-6">
                <h3 className="text-xl font-bold">
                  Annual Savings Calculator: Partial Exemption (Section 11.22)
                </h3>
                <p className="text-teal-100 mt-2">
                  Based on El Paso combined tax rate of approximately 2.69%
                </p>
              </div>
              <div className="p-6">
                <div className="overflow-x-auto">
                  <table className="w-full text-left">
                    <thead>
                      <tr className="border-b-2 border-gray-200">
                        <th className="py-3 px-4 text-gray-900 font-bold">VA Rating</th>
                        <th className="py-3 px-4 text-gray-900 font-bold">Exemption Amount</th>
                        <th className="py-3 px-4 text-gray-900 font-bold">Annual Savings</th>
                        <th className="py-3 px-4 text-gray-900 font-bold">10-Year Savings</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr className="border-b border-gray-100">
                        <td className="py-3 px-4 text-gray-700">10% - 29%</td>
                        <td className="py-3 px-4 text-gray-700">$5,000</td>
                        <td className="py-3 px-4 text-teal-600 font-semibold">$135</td>
                        <td className="py-3 px-4 text-teal-600 font-semibold">$1,345</td>
                      </tr>
                      <tr className="border-b border-gray-100 bg-gray-50">
                        <td className="py-3 px-4 text-gray-700">30% - 49%</td>
                        <td className="py-3 px-4 text-gray-700">$7,500</td>
                        <td className="py-3 px-4 text-teal-600 font-semibold">$202</td>
                        <td className="py-3 px-4 text-teal-600 font-semibold">$2,018</td>
                      </tr>
                      <tr className="border-b border-gray-100">
                        <td className="py-3 px-4 text-gray-700">50% - 69%</td>
                        <td className="py-3 px-4 text-gray-700">$10,000</td>
                        <td className="py-3 px-4 text-teal-600 font-semibold">$269</td>
                        <td className="py-3 px-4 text-teal-600 font-semibold">$2,690</td>
                      </tr>
                      <tr className="bg-teal-50">
                        <td className="py-3 px-4 text-gray-700 font-semibold">70% - 100%</td>
                        <td className="py-3 px-4 text-gray-700 font-semibold">$12,000</td>
                        <td className="py-3 px-4 text-teal-600 font-bold">$323</td>
                        <td className="py-3 px-4 text-teal-600 font-bold">$3,228</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-xl shadow-lg overflow-hidden mb-8">
              <div className="bg-gray-900 text-white p-6">
                <h3 className="text-xl font-bold">
                  Annual Savings Calculator: 100% Total Exemption (Section 11.131)
                </h3>
                <p className="text-gray-300 mt-2">
                  Complete property tax elimination for 100% rated or TDIU veterans
                </p>
              </div>
              <div className="p-6">
                <div className="overflow-x-auto">
                  <table className="w-full text-left">
                    <thead>
                      <tr className="border-b-2 border-gray-200">
                        <th className="py-3 px-4 text-gray-900 font-bold">Home Value</th>
                        <th className="py-3 px-4 text-gray-900 font-bold">Normal Tax Bill</th>
                        <th className="py-3 px-4 text-gray-900 font-bold">With 100% Exemption</th>
                        <th className="py-3 px-4 text-gray-900 font-bold">Annual Savings</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr className="border-b border-gray-100">
                        <td className="py-3 px-4 text-gray-700">$150,000</td>
                        <td className="py-3 px-4 text-gray-700">$4,035</td>
                        <td className="py-3 px-4 text-teal-600 font-bold">$0</td>
                        <td className="py-3 px-4 text-teal-600 font-bold">$4,035</td>
                      </tr>
                      <tr className="border-b border-gray-100 bg-gray-50">
                        <td className="py-3 px-4 text-gray-700">$200,000</td>
                        <td className="py-3 px-4 text-gray-700">$5,380</td>
                        <td className="py-3 px-4 text-teal-600 font-bold">$0</td>
                        <td className="py-3 px-4 text-teal-600 font-bold">$5,380</td>
                      </tr>
                      <tr className="border-b border-gray-100">
                        <td className="py-3 px-4 text-gray-700">$250,000</td>
                        <td className="py-3 px-4 text-gray-700">$6,725</td>
                        <td className="py-3 px-4 text-teal-600 font-bold">$0</td>
                        <td className="py-3 px-4 text-teal-600 font-bold">$6,725</td>
                      </tr>
                      <tr className="border-b border-gray-100 bg-gray-50">
                        <td className="py-3 px-4 text-gray-700">$300,000</td>
                        <td className="py-3 px-4 text-gray-700">$8,070</td>
                        <td className="py-3 px-4 text-teal-600 font-bold">$0</td>
                        <td className="py-3 px-4 text-teal-600 font-bold">$8,070</td>
                      </tr>
                      <tr className="bg-teal-50">
                        <td className="py-3 px-4 text-gray-700 font-semibold">$400,000</td>
                        <td className="py-3 px-4 text-gray-700 font-semibold">$10,760</td>
                        <td className="py-3 px-4 text-teal-600 font-bold">$0</td>
                        <td className="py-3 px-4 text-teal-600 font-bold">$10,760</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <p className="text-gray-700 leading-relaxed mb-6">
              These numbers demonstrate why the 100 percent disabled veteran property tax exemption is so extraordinarily valuable. A veteran with a $250,000 home in El Paso saves nearly $6,725 every single year. Over a 20-year period, that totals $134,500 in savings. Even the partial exemptions provide meaningful relief. A veteran with a 50 percent rating saves $269 per year, which adds up to $2,690 over a decade. Every dollar counts, especially for veterans managing medical expenses and other costs associated with their service-connected disabilities.
            </p>
            <p className="text-gray-700 leading-relaxed mb-6">
              It is worth noting that these calculations assume the standard El Paso combined tax rate. Your actual rate may vary slightly depending on your specific location within the county. Properties in the City of El Paso have different rates than properties in unincorporated areas or in the Town of Anthony, Horizon City, or other municipalities. You can find your exact tax rate by looking up your property on the{' '}
              <a
                href="/elpaso-tx/how-to-pay-property-tax"
                className="text-teal-600 hover:text-teal-700 font-semibold"
              >
                El Paso County Tax Assessor-Collector payment portal
              </a>{' '}
              or by contacting EPCAD directly. The principle remains the same regardless of your exact rate: the disabled veteran exemption reduces your taxable value, and the higher your combined rate, the more you save.
            </p>
            <p className="text-gray-700 leading-relaxed">
              For veterans who also qualify for the standard residential homestead exemption, the savings stack together. If you have a 40 percent VA rating and you also have the general homestead exemption, your taxable value for school district purposes is reduced by $100,000 from the homestead exemption plus $7,500 from the disabled veteran exemption, for a total reduction of $107,500. For other taxing entities, the homestead exemption amounts vary, but the disabled veteran exemption applies across all entities. Filing for both exemptions simultaneously through your{' '}
              <a
                href="/elpaso-tx/homestead-exemption-how-to"
                className="text-teal-600 hover:text-teal-700 font-semibold"
              >
                El Paso homestead exemption application
              </a>{' '}
              ensures you receive the maximum possible savings.
            </p>
          </div>
        </div>
      </section>

      {/* Application Forms Section */}
      <section id="forms" className="mb-12 scroll-mt-24">
        <div className="max-w-4xl mx-auto px-6">
          <h2 className="text-3xl font-bold text-gray-900 mb-6">
            Texas Disabled Veteran Property Tax Exemption Form: What You Need
          </h2>

          <div className="mb-10">
            <img
              src="https://readdy.ai/api/search-image?query=official%20texas%20property%20tax%20exemption%20application%20forms%20spread%20on%20desk%20with%20va%20disability%20letter%20military%20service%20records%20dog%20tags%20pen%20and%20reading%20glasses%20organized%20paperwork%20warm%20natural%20lighting%20professional%20document%20photography&width=800&height=500&seq=dv-forms-804&orientation=landscape"
              alt="Texas disabled veteran property tax exemption form and required VA documentation"
              className="w-full h-80 object-cover object-top rounded-xl shadow-lg mb-6"
            />
          </div>

          <div className="prose prose-lg max-w-none">
            <p className="text-gray-700 leading-relaxed mb-6">
              The Texas disabled veteran property tax exemption form you need depends on which exemption you are applying for. The Texas Comptroller of Public Accounts provides standardized forms that are used by all appraisal districts across the state, including EPCAD in El Paso. Understanding which form to use and what supporting documents to gather before you begin will streamline the process and help you avoid delays caused by incomplete applications.
            </p>
            <p className="text-gray-700 leading-relaxed mb-6">
              For the standard partial disabled veteran exemption under Section 11.22, you will use the Texas Comptroller Form 50-135, officially titled Application for Disabled Veteran&apos;s or Survivor&apos;s Exemption. This is the same form used for all disability rating levels from 10 percent through 100 percent under the standard program. The form asks for your personal information, property details, VA disability rating, and requires you to attach supporting documentation from the Department of Veterans Affairs.
            </p>
            <p className="text-gray-700 leading-relaxed mb-6">
              For the 100 percent disabled veteran property tax exemption under Section 11.131, you will also use Form 50-135 but will check the specific box indicating that you are applying for the total exemption based on a 100 percent disability rating or TDIU determination. Some appraisal districts, including EPCAD, may also accept the general homestead exemption application Form 50-114 with the disabled veteran section completed. However, using Form 50-135 is recommended because it is specifically designed for disabled veteran exemptions and ensures all required information is captured.
            </p>

            <div className="bg-white rounded-xl shadow-lg p-8 mb-8">
              <h3 className="text-xl font-bold text-gray-900 mb-6">
                Required Documents Checklist
              </h3>
              <div className="grid md:grid-cols-2 gap-6">
                <div>
                  <h4 className="font-semibold text-gray-900 mb-3 flex items-center">
                    <i className="ri-file-list-3-line text-teal-600 mr-2"></i>
                    For All Disabled Veterans
                  </h4>
                  <ul className="space-y-2">
                    <li className="flex items-start">
                      <i className="ri-checkbox-circle-fill text-teal-600 text-lg mr-2 mt-0.5 flex-shrink-0"></i>
                      <span className="text-gray-700">Completed Form 50-135</span>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-checkbox-circle-fill text-teal-600 text-lg mr-2 mt-0.5 flex-shrink-0"></i>
                      <span className="text-gray-700">VA Disability Rating Letter (current)</span>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-checkbox-circle-fill text-teal-600 text-lg mr-2 mt-0.5 flex-shrink-0"></i>
                      <span className="text-gray-700">Texas Driver&apos;s License or State ID</span>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-checkbox-circle-fill text-teal-600 text-lg mr-2 mt-0.5 flex-shrink-0"></i>
                      <span className="text-gray-700">DD-214 (Certificate of Release or Discharge)</span>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-checkbox-circle-fill text-teal-600 text-lg mr-2 mt-0.5 flex-shrink-0"></i>
                      <span className="text-gray-700">Property account number from EPCAD</span>
                    </li>
                  </ul>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900 mb-3 flex items-center">
                    <i className="ri-shield-star-line text-teal-600 mr-2"></i>
                    Additional for 100% / TDIU
                  </h4>
                  <ul className="space-y-2">
                    <li className="flex items-start">
                      <i className="ri-checkbox-circle-fill text-teal-600 text-lg mr-2 mt-0.5 flex-shrink-0"></i>
                      <span className="text-gray-700">
                        VA Benefits Summary Letter showing 100% or TDIU
                      </span>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-checkbox-circle-fill text-teal-600 text-lg mr-2 mt-0.5 flex-shrink-0"></i>
                      <span className="text-gray-700">VA Rating Decision Letter (if recently changed)</span>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-checkbox-circle-fill text-teal-600 text-lg mr-2 mt-0.5 flex-shrink-0"></i>
                      <span className="text-gray-700">Proof of homestead occupancy (utility bill, etc.)</span>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-checkbox-circle-fill text-teal-600 text-lg mr-2 mt-0.5 flex-shrink-0"></i>
                      <span className="text-gray-700">Vehicle registration showing property address</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <p className="text-gray-700 leading-relaxed mb-6">
              The most critical document in your application is the VA Disability Rating Letter, also known as the VA Benefits Summary Letter. This letter confirms your disability rating percentage and indicates whether your disabilities are service-connected. You can obtain a current copy of this letter by logging into your VA.gov account, calling the VA at 1-800-827-1000, or visiting the Fort Bliss VA clinic. EPCAD requires this letter to verify your eligibility, and it must be current. An outdated letter showing a previous rating will not be accepted if your rating has changed.
            </p>
            <p className="text-gray-700 leading-relaxed mb-6">
              Your DD-214 is your official military discharge document that proves you served in the armed forces. If you do not have a copy of your DD-214, you can request one from the National Personnel Records Center through the National Archives website or by submitting Standard Form 180. Many veterans who served decades ago may have misplaced this document, but it is essential for the exemption application. The El Paso County Veterans Service Office can also assist you in obtaining a replacement copy.
            </p>
            <p className="text-gray-700 leading-relaxed">
              How do I apply for disabled veterans property tax exemption in Texas? The process begins with gathering these documents and completing the appropriate form. You can download Form 50-135 from the Texas Comptroller&apos;s website or pick up a copy at the EPCAD office located at 5801 Trowbridge Drive in El Paso. Once you have all documents assembled, you can submit your application in person, by mail, or in some cases electronically. The next section provides the complete step-by-step application process specific to El Paso County.
            </p>
          </div>
        </div>
      </section>

      {/* Step-by-Step Application Process */}
      <section id="application-process" className="mb-12 scroll-mt-24">
        <div className="max-w-4xl mx-auto px-6">
          <h2 className="text-3xl font-bold text-gray-900 mb-6">
            How Do I Apply for Disabled Veterans Property Tax Exemption in Texas: Step-by-Step
          </h2>

          <div className="mb-10">
            <img
              src="https://readdy.ai/api/search-image?query=military%20veteran%20in%20casual%20clothing%20walking%20into%20modern%20government%20office%20building%20carrying%20folder%20of%20documents%20el%20paso%20texas%20bright%20sunny%20day%20professional%20architecture%20clean%20entrance%20professional%20photography&width=800&height=500&seq=dv-apply-805&orientation=landscape"
              alt="Veteran visiting EPCAD office in El Paso to apply for disabled veteran property tax exemption"
              className="w-full h-80 object-cover object-top rounded-xl shadow-lg mb-6"
            />
          </div>

          <div className="prose prose-lg max-w-none">
            <p className="text-gray-700 leading-relaxed mb-6">
              The disabled veteran property tax exemption application process in El Paso is straightforward when you have all your documents prepared. EPCAD has made the process as veteran-friendly as possible, and their staff is experienced in handling military exemption applications. Here is the exact step-by-step process for how to apply for disabled veterans property tax exemption in Texas through the El Paso Central Appraisal District.
            </p>

            <div className="space-y-6 mb-8">
              <div className="flex items-start bg-white rounded-xl shadow-md p-6">
                <div className="w-12 h-12 bg-teal-600 text-white rounded-full flex items-center justify-center flex-shrink-0 mr-5 text-lg font-bold">
                  1
                </div>
                <div>
                  <h4 className="font-bold text-gray-900 text-lg mb-2">
                    Obtain Your Current VA Disability Rating Letter
                  </h4>
                  <p className="text-gray-700 leading-relaxed">
                    Log into VA.gov and navigate to the Letters section to download your Benefits Summary Letter. This letter must show your current disability rating percentage and confirm that your conditions are service-connected. If you recently received a rating increase, make sure the letter reflects the updated percentage. You can also call 1-800-827-1000 to request a letter by mail or visit the Fort Bliss VA clinic for in-person assistance.
                  </p>
                </div>
              </div>

              <div className="flex items-start bg-white rounded-xl shadow-md p-6">
                <div className="w-12 h-12 bg-teal-600 text-white rounded-full flex items-center justify-center flex-shrink-0 mr-5 text-lg font-bold">
                  2
                </div>
                <div>
                  <h4 className="font-bold text-gray-900 text-lg mb-2">
                    Locate Your Property Account Number
                  </h4>
                  <p className="text-gray-700 leading-relaxed">
                    Find your EPCAD property account number on your most recent property tax statement or by using the{' '}
                    <a
                      href="/elpaso-tx/challenge-home-value"
                      className="text-teal-600 hover:text-teal-700 font-semibold"
                    >
                      EPCAD property search tool to look up your assessment
                    </a>
                    . You can search by your name, address, or legal description. Write down the full account number as you will need it on the application form.
                  </p>
                </div>
              </div>

              <div className="flex items-start bg-white rounded-xl shadow-md p-6">
                <div className="w-12 h-12 bg-teal-600 text-white rounded-full flex items-center justify-center flex-shrink-0 mr-5 text-lg font-bold">
                  3
                </div>
                <div>
                  <h4 className="font-bold text-gray-900 text-lg mb-2">
                    Download and Complete Form 50-135
                  </h4>
                  <p className="text-gray-700 leading-relaxed">
                    Download the Application for Disabled Veteran&apos;s or Survivor&apos;s Exemption from the Texas Comptroller website. Fill in all required fields including your name, property address, account number, VA disability rating percentage, and the type of exemption you are requesting. If you qualify for the 100 percent total exemption, check the appropriate box in Section 11.131. Sign and date the form.
                  </p>
                </div>
              </div>

              <div className="flex items-start bg-white rounded-xl shadow-md p-6">
                <div className="w-12 h-12 bg-teal-600 text-white rounded-full flex items-center justify-center flex-shrink-0 mr-5 text-lg font-bold">
                  4
                </div>
                <div>
                  <h4 className="font-bold text-gray-900 text-lg mb-2">
                    Gather All Supporting Documents
                  </h4>
                  <p className="text-gray-700 leading-relaxed">
                    Assemble copies of your VA Disability Rating Letter, DD-214, Texas driver&apos;s license or state ID showing your property address, and any additional documentation required for your specific situation. Make photocopies of everything before submitting. EPCAD will keep the copies you submit and will not return original documents.
                  </p>
                </div>
              </div>

              <div className="flex items-start bg-white rounded-xl shadow-md p-6">
                <div className="w-12 h-12 bg-teal-600 text-white rounded-full flex items-center justify-center flex-shrink-0 mr-5 text-lg font-bold">
                  5
                </div>
                <div>
                  <h4 className="font-bold text-gray-900 text-lg mb-2">
                    Submit Your Application to EPCAD
                  </h4>
                  <p className="text-gray-700 leading-relaxed">
                    You have three submission options. In person: Visit the EPCAD office at 5801 Trowbridge Drive, El Paso, TX 79925, Monday through Friday, 8:00 AM to 5:00 PM. By mail: Send your completed application and copies of all supporting documents to EPCAD at the same address. Online: Check the EPCAD website for electronic submission options, which may be available depending on current processing capabilities.
                  </p>
                </div>
              </div>

              <div className="flex items-start bg-white rounded-xl shadow-md p-6">
                <div className="w-12 h-12 bg-teal-600 text-white rounded-full flex items-center justify-center flex-shrink-0 mr-5 text-lg font-bold">
                  6
                </div>
                <div>
                  <h4 className="font-bold text-gray-900 text-lg mb-2">
                    Receive Confirmation and Verify Your Account
                  </h4>
                  <p className="text-gray-700 leading-relaxed">
                    After EPCAD processes your application, you will receive a written confirmation indicating whether your exemption was approved. Processing typically takes two to four weeks. Once approved, verify that the exemption appears correctly on your property account by searching your property on the EPCAD website. The exemption should be listed under the exemptions section of your account detail page.
                  </p>
                </div>
              </div>
            </div>

            <p className="text-gray-700 leading-relaxed">
              The entire process from gathering documents to receiving confirmation typically takes four to six weeks. If you submit your application early in the year, well before the April 30th deadline, you give EPCAD ample time to process it and apply the exemption to your current tax year. Veterans who miss the deadline can still apply, but the exemption may not take effect until the following tax year. There is no fee to apply for the disabled veteran property tax exemption, and you only need to apply once unless your disability rating changes or you move to a different property.
            </p>
          </div>
        </div>
      </section>
    </>
  );
}
